import { render, staticRenderFns } from "./lhcWinTable.vue?vue&type=template&id=587b9d2a&scoped=true"
import script from "./lhcWinTable.vue?vue&type=script&lang=ts"
export * from "./lhcWinTable.vue?vue&type=script&lang=ts"
import style0 from "./lhcWinTable.vue?vue&type=style&index=0&id=587b9d2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b9d2a",
  null
  
)

export default component.exports